/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */
import {get, post} from '../request'
import {token} from "./token";
import {store} from "../../store";
import {login as dispatch_login, logout as dispatch_logout, setUserInfo,} from "../../reducers/auth-reducer";

export async function getUserInfo() {
    return get("auth/self").done((data) => store.dispatch(setUserInfo(data['data'])));
}

export function isLoggedIn() {
    const auth = store.getState().auth;
    if (!auth.isAuthenticated && !token.isExpired()) {
        store.dispatch(dispatch_login());
    }
    if (!token.isExpired() && auth.userInfo == null) {
        getUserInfo();
    }
}

export function login(username: string, password: string): JQueryPromise<any> {
    return post("auth/login", {
        'user': username,
        'password': password
    }).done(
        () => store.dispatch(dispatch_login())
    ).done(
        () => getUserInfo()
    )
}


export function logout() {
    if (token.exists()) {
        return get("auth/logout").always(() => {
            token.del();
            store.dispatch(dispatch_logout());
        })
    } else {
        store.dispatch(dispatch_logout());
    }

}